import { render, staticRenderFns } from "./ExamPackage.vue?vue&type=template&id=cbe35fba&scoped=true&"
import script from "./ExamPackage.vue?vue&type=script&lang=js&"
export * from "./ExamPackage.vue?vue&type=script&lang=js&"
import style0 from "./ExamPackage.vue?vue&type=style&index=0&id=cbe35fba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbe35fba",
  null
  
)

export default component.exports